<!--
  ~ Copyright 2022-2023 NXGN Management, LLC. All Rights Reserved.
  -->
<div class="table-block">
  <div class="recordRow">
    <div class="recordLabel">First Name</div>
    <div id="primaryContactFirstName" class="recordValue">
      {{ merchant.primaryContactFirstName }}
    </div>
  </div>
  <div class="recordRow">
    <div class="recordLabel">Last Name</div>
    <div id="primaryContactLastName" class="recordValue">
      {{ merchant.primaryContactLastName }}
    </div>
  </div>

  <div class="recordRow">
    <div class="recordLabel">Email</div>
    <div id="primaryContactEmail" class="recordValue">
      {{ merchant.primaryContactEmail }}
    </div>
  </div>

  <div class="recordRow">
    <div class="recordLabel">Phone Number</div>
    <div id="primaryContactPhoneNumber" class="recordValue">
      {{ merchant.primaryContactPhoneNumber }}
    </div>
  </div>
</div>
